import { render, staticRenderFns } from "./CommentIcon.vue?vue&type=template&id=8c1da81a&scoped=true"
import script from "./CommentIcon.vue?vue&type=script&lang=js"
export * from "./CommentIcon.vue?vue&type=script&lang=js"
import style0 from "./CommentIcon.vue?vue&type=style&index=0&id=8c1da81a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1da81a",
  null
  
)

export default component.exports